module.exports = __webpack_public_path__ + "static/media/29BDOS6.550e87d0.jpg";